import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAutotaskPodData } from 'services/pod';
import { IPodData } from 'services/pod/types';

interface IProps {
  psaId: number;
  ticketId: string;
}

export const ThunkGetAutotaskPodData = createAsyncThunk<IPodData, IProps>(
  'pod/getAutotaskPodData',
  async ({ psaId, ticketId }) => {
    const r = await getAutotaskPodData(psaId, ticketId);
    return r.data;
  },
);
